import { CellContext } from '@tanstack/react-table';

import { Authorized } from '@/react/hooks/useUser';
import { useDisconnectContainer } from '@/react/docker/networks/queries/useDisconnectContainerMutation';
import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { notifySuccess } from '@/portainer/services/notifications';

import { LoadingButton } from '@@/buttons';

import { TableNetwork, isContainerNetworkTableMeta } from './types';
import { columnHelper } from './helper';

export function buildActions({ nodeName }: { nodeName?: string } = {}) {
  return columnHelper.display({
    header: '操作',
    cell: Cell,
  });

  function Cell({
    row: {
      original: { id: networkId },
    },
    table: {
      options: { meta },
    },
  }: CellContext<TableNetwork, unknown>) {
    const environmentId = useEnvironmentId();
    const disconnectMutation = useDisconnectContainer({
      environmentId,
      networkId,
    });

    return (
      <Authorized authorizations="DockerNetworkDisconnect">
        <LoadingButton
          color="dangerlight"
          data-cy="disconnect-network-button"
          isLoading={disconnectMutation.isLoading}
          loadingText="正在离开网络..."
          type="button"
          onClick={handleSubmit}
        >
          离开网络
        </LoadingButton>
      </Authorized>
    );

    function handleSubmit() {
      if (!isContainerNetworkTableMeta(meta)) {
        throw new Error('Invalid row meta');
      }

      disconnectMutation.mutate(
        {
          containerId: meta.containerId,
          nodeName,
        },
        {
          onSuccess() {
            notifySuccess('容器已成功断开连接', networkId);
          },
        }
      );
    }
  }
}
